import React from 'react';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';
import tinycolor from 'tinycolor2';
import uniqueId from 'lodash-es/uniqueId';

const AddColorButton = () => {

    const dispatch = useAppDispatch();
    const colors = useAppSelector(store => store.form.colors);

    const addColorHandler = () => {
        const copy = [...colors];

        const color = tinycolor.random();
        const argb = color.toRgb();

        copy.push({ r: argb.r, g: argb.g, b: argb.b, a: 1, cid: uniqueId() });

        dispatch(
            formActions.main({
                colors: copy,
            })
        );
    };

    return (
        <button
            type="button"
            className="bg-green-200 text-gray-700 rounded-full px-6 py-2 whitespace-nowrap"
            onClick={ addColorHandler }>+ Add Color</button>
    )
};

export default AddColorButton;